export default __webpack_public_path__ + "static/media/blockchain-image-3steg.2037f25d.jpg";